import { Routes } from '@angular/router';

import { azureManagementSegments } from '@advania-cosoftware/wolf-router';

export const azureManagementRoutes: Routes = [
    {
        path: azureManagementSegments.azureManagement,
        loadComponent: () =>
            import('./features/home/azure-management-home/azure-management-home.page').then(
                (m) => m.AzureManagementHomePage,
            ),
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: azureManagementSegments.logs,
            },
            {
                path: azureManagementSegments.logs,
                loadComponent: () =>
                    import('./features/logs/azure-management-logs/azure-management-logs.page').then(
                        (m) => m.AzureManagementLogsPage,
                    ),
            },
            {
                path: azureManagementSegments.inventory,
                loadComponent: () =>
                    import('./features/inventory/azure-management-inventory/azure-management-inventory.page').then(
                        (m) => m.AzureManagementInventoryPage,
                    ),
            },
            {
                path: azureManagementSegments.budgets,
                loadComponent: () =>
                    import('./features/budgets/azure-management-budgets/azure-management-budgets.page').then(
                        (m) => m.AzureManagementBudgetsPage,
                    ),
            },
        ],
    },
];
